module.exports = __webpack_public_path__ + "static/media/butter-robot-image-5.a21162fa.jpg";